import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'sb-statistic-card',
  templateUrl: './statistic-card.component.html',
  styleUrls: ['./statistic-card.component.scss'],
  standalone: false,
})
export class StatisticCardComponent implements OnInit {
  @Input() icon: string;
  @Input() value: string;
  @Input() description: string;

  constructor() {}

  ngOnInit(): void {}
}
